import {z} from 'zod';

export const PNC_CODE_MAX_LENGTH = 6;

export const EMPTY_DTC_CODE = {value: ''};

export const mazdaAdditionalInformationFormSchema = z.object({
  assemblyGroup: z.string().nullish(),
  subAssemblyGroup: z.string().nullish(),
  pncCode: z.string().max(PNC_CODE_MAX_LENGTH).nullish(),
  symptomCode: z.string().nullish(),
  damageCode: z.string().nullish(),
  locationCodes: z.array(z.string()).nullish(),
  dtcCodes: z.array(z.object({value: z.string()})),
});

export type MazdaAdditionalInformationFormType = z.infer<
  typeof mazdaAdditionalInformationFormSchema
>;
